// highchartsSetup.ts
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import OfflineExporting from "highcharts/modules/offline-exporting";

Exporting(Highcharts);
OfflineExporting(Highcharts);

export default Highcharts;